import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ai-exclusive-collections',
  templateUrl: './ai-exclusive-collections.component.html',
  styleUrls: ['./ai-exclusive-collections.component.scss']
})
export class AIExclusiveCollectionsComponent implements OnInit {
  slidesData: any = [];
  exclusiveData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getExclusiveBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
    });

    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.exclusiveData = [];

        this.exclusiveData = singleservice.filter((data)=>{
          return data["isExclusive"] && data["isAICollection"]
        })

        //console.log(this.exclusiveData);
      }
    );
  }

}
